import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  isLoggedIn: true,
  hasAccessToFeatures: true,
  userToDeact: {},
}

const store = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    updateRole: (state) => {
      state.role = 'dev'
    },
    updateAccessToFeatures: (state, { payload }) => {
      if (payload) {
        state.hasAccessToFeatures = payload
      } else {
        state.hasAccessToFeatures = true
      }
    },
    setUserToDeact: (state, { payload }) => {
      if (payload) {
        state.userToDeact = payload
      } else {
        state.userToDeact = null
      }
    },
  },
})

export default store
